export const categories = [
  {
    id: 'mingxing-heiliao',
    name: '明星黑料',
    slug: 'mingxing-heiliao',
    description: '最新明星八卦、内幕爆料，深度揭秘娱乐圈明星不为人知的一面',
    icon: 'ri-spy-line',
    color: 'bg-red-500',
    articleCount: 128,
  },
  {
    id: 'wanghong-bagua',
    name: '网红爆料',
    slug: 'wanghong-bagua',
    description: '网红圈最新黑料、翻车事件、行业内幕全收录',
    icon: 'ri-live-line',
    color: 'bg-orange-500',
    articleCount: 96,
  },
  {
    id: 'yulequan-neimu',
    name: '娱乐圈内幕',
    slug: 'yulequan-neimu',
    description: '娱乐圈潜规则、行业内幕、资本博弈深度解析',
    icon: 'ri-eye-off-line',
    color: 'bg-rose-500',
    articleCount: 87,
  },
  {
    id: 'zongyi-jiemu',
    name: '综艺节目',
    slug: 'zongyi-jiemu',
    description: '综艺节目幕后故事、选手黑料、节目造假揭秘',
    icon: 'ri-tv-line',
    color: 'bg-amber-500',
    articleCount: 74,
  },
  {
    id: 'yingshi-dongtai',
    name: '影视动态',
    slug: 'yingshi-dongtai',
    description: '影视圈最新动态、剧组内幕、演员恩怨全知道',
    icon: 'ri-film-line',
    color: 'bg-pink-500',
    articleCount: 63,
  },
  {
    id: 'yinyue-quan',
    name: '音乐圈',
    slug: 'yinyue-quan',
    description: '音乐圈抄袭风波、假唱事件、歌手恩怨揭秘',
    icon: 'ri-music-line',
    color: 'bg-purple-500',
    articleCount: 52,
  },
];